import React from "react";
import styles from "../EventsPage.module.css";

export function YearFilterTabs({ options, activeValue, onChange }) {
  return (
    <div className={styles.yearTabs} role="tablist" aria-label="Filter events by year">
      {options.map((opt) => {
        const isActive = opt === activeValue;
        return (
          <button
            key={opt}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`${styles.yearTab} ${isActive ? styles.yearTabActive : ""}`.trim()}
            onClick={() => onChange(opt)}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}
